/**
 * Obtiene la variante del badge según el estado activo/inactivo
 */
export const getStatusVariant = (isActive) => {
  return isActive ? 'success' : 'warning';
};

/**
 * Obtiene la URL del logo de la empresa
 */
export const getCompanyLogo = (company, logoError) => {
  // Si hay un error al cargar la imagen, usar el fallback
  if (logoError) {
    return '/img/empty_company.png';
  }
  
  const logoBase64 = company?.ImgLogo || company?.logoBase64;
  if (logoBase64 && logoBase64.trim() !== '') {
    return `data:image/png;base64,${logoBase64}`;
  }
  // Fallback a logo por defecto si no hay logo
  return '/img/empty_company.png';
};

